import type { UseQueryResult } from '@tanstack/react-query';
import { useBasicQuery } from '@hooks/requests/utils/use_basic_query';
import { PARTNER_USERS_PATH } from '@hooks/requests/utils/paths';

export interface PartnerUser {
  company_id: string;
  company_name: string;
  country: string;
  created_at: string;
  first_name: string;
  organization_id: string;
  timezone: string;
  updated_at: string;
  user_id: string;
}

export interface UseAllUsersParams {
  /**
   * AceUpAdmin/AceUpViewer only — scopes the request to this organization.
   * The backend falls back to the caller's own org_id (JWT) when omitted,
   * which is *not* what an AceUp dashboard session wants once an org has
   * been picked, so callers should pass the selected org here rather than
   * relying on that fallback. Ignored (and unnecessary) for PartnerAdmin,
   * whose org_id always comes from the JWT.
   */
  organizationId?: string | null;
  /** Defaults to `true`. Use to defer the request (e.g. until an org is selected). */
  enabled?: boolean;
}

export const useAllUsersQuery = ({
  organizationId,
  enabled,
}: UseAllUsersParams = {}): UseQueryResult<PartnerUser[], Error> =>
  useBasicQuery<PartnerUser[]>(
    PARTNER_USERS_PATH,
    organizationId ? { organization_id: organizationId } : undefined,
    { enabled }
  );
